export default {
  community: {
    follow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'community',
        community: '',
        state: 'pending',
      },
    },
    unfollow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'community',
        community: '',
        state: 'not_following',
      },
    },
    remove: {
      url: '/api/community/remove/',
      params: {
        service: 'community',
        community_id: '',
        user_id: '',
      },
    },
    approve: {
      url: '/api/community/approve/',
      params: {
        service: 'community',
        community_id: '',
        user_id: '',
      },
    },
    promote: {
      url: '/api/community/promote/',
      params: {
        service: 'community',
        community_id: '',
        user_id: '',
      },
    },
    demote: {
      url: '/api/community/demote/',
      params: {
        service: 'community',
        community_id: '',
        user_id: '',
      },
    },
  },
  golfcourse: {
    follow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'golf_course',
        golf_course: '',
        state: 'following',
      },
    },
    unfollow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'golf_course',
        golf_course: '',
        state: 'not_following',
      },
    },
  },
  tournament: {
    follow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'tournament',
        tournament: '',
        state: 'following',
      },
    },
    unfollow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'tournament',
        tournament: '',
        state: 'not_following',
      },
    },
  },
  user: {
    updateProfileImage: {
      url: '/api/file/upload/image/',
      params: {
        service: 'user',
        user: '',
        image_type: 'avatar',
        thumb_type: 'small_avatar',
      },
    },
    follow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'user',
        user: '',
        state: 'following',
      },
    },
    unfollow: {
      url: '/api/timeline/follow/',
      params: {
        service: 'user',
        user: '',
        state: 'not_following',
      },
    },
  },
  timeline: {
    getTimelineData: {
      url: '/api/timeline/',
      params: {
        offset: 0,
        limit: 10,
        type: 'personal',
      },
    },

  },
  scorecard: {
    getGolfCourses: {
      url: '/api/score-card/session/clubs/',
    },
    postGolfCourse: {
      url: '/api/score-card/session/clubs/',
      params: {
        club_id: '',
      },
    },
    postGolfCourseLoops: {
      url: '/api/score-card/session/loops/',
      params: {
        loop_id: '',
      },
    },
    postGolfCourseTees: {
      url: '/api/score-card/session/tees/',
      params: {
        tee_id: '',
      },
    },
    submitGolfCourse: {
      url: '/api/score-card/session/create/',
      params: {
        date: '',
        card_type: '',
      },
    },
    getScorecardInfo: {
      url: '/api/score-card/session/{uuid}/info/',
    },
    finalizeScorecard: {
      url: '/api/score-card/session/finalize/',
      params: {
        session: '',
        holes: [],
      },
    },
    finalizeForeignScorecard: {
      url: '/api/score-card/session/foreign/',
      params: {
        date: '',
        country: '',
        course: '',
        loop: '',
        tee: '',
        holes: '',
        courseRating: '',
        slopeRating: '',
        par: '',
        stableford: '',
      },
    },
  },
  comment: {
    addComment: {
      url: '/api/comment/add/',
      params: {
        message_id: '',
        comment: '',
      },
    },
    removeComment: {
      url: '/api/comment/remove/',
      params: {
        comment_id: '',
      },
    },
    editComment: {
      url: '/api/comment/edit/',
      params: {
        comment_id: '',
        comment: '',
      },
    },
    likeMessage: {
      url: '/api/comment/like/',
      params: {
        message_id: '',
        type: 'like',
      },
    },
    unlikeMessage: {
      url: '/api/comment/like/',
      params: {
        message_id: '',
        type: 'undo',
      },
    },
  },
  partnerCourses: {
    getCourses: {
      url: '/api/golf-courses/club-pga/',
      params: {
        offset: 0,
        limit: 6,
      },
    },
  },
};
